import Repository from "./Repository";
const NEW_LEAD = "/leads";
export default {
  createNewLead(payload) {
    // console.log(payload, "payload");
    return Repository.post(`${NEW_LEAD}`, payload);
  },
};
